export function getRoundedCurrentLocalDateTime() {
    const now = new Date();
    now.setMinutes(0, 0, 0);
    const tzOffsetMs = now.getTimezoneOffset() * 60000;
    const local = new Date(now.getTime() - tzOffsetMs);
    return local.toISOString().slice(0, 16);
}

export function getArticleEditsStorageKey(articleId) {
    return `newsQueue.articleEdits.${articleId}`;
}
